module.exports = __webpack_public_path__ + "static/media/puc-only-mobile.21dbafc3.svg";